import { render, staticRenderFns } from "./BlogListingsSection.vue?vue&type=template&id=22209aca&scoped=true&"
import script from "./BlogListingsSection.vue?vue&type=script&lang=js&"
export * from "./BlogListingsSection.vue?vue&type=script&lang=js&"
import style0 from "./BlogListingsSection.vue?vue&type=style&index=0&id=22209aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22209aca",
  null
  
)

export default component.exports